import classes from './PermissionDenied.module.css';
import Footer from '../LandingPage/Footer/Footer';
import CordobaLogo from '../../assets/images/header/logo-cordoba-blanco.svg';
import WhatsappIcon from '../../assets/images/whatsapp.svg';
import MailIcon from '../../assets/images/mail.svg';
import SinPermiso from '../../assets/images/sinPermiso.png';

export const PermissionDenied = () => {
  const handleBack = () => {
    window.history.back();
  };

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <img className={classes.logo} src={CordobaLogo} alt="logo de córdoba" />
      </header>
      <div className={classes.container}>
        <h1 className={classes.subtitle}>No posee permisos para ingresar</h1>
        <section className={classes.content}>
          <article className={classes.info}>
            <p>Para solicitar permiso sobre este servicio comuníquese al:</p>
            <div className={classes.contact}>
              <img src={WhatsappIcon} alt="logo de córdoba" />
              <a
                href="https://wa.me/+5493514285656?text=Hola%21%20Me%20gustar%C3%ADa%20recibir%20ayuda%20con%20"
                target="_blank"
                rel="noopener noreferrer"
              >
                +54 9 351-428-5656
              </a>
            </div>

            <div className={classes.contact}>
              <img src={MailIcon} alt="logo de córdoba" />

              <a href={'mailto:mesadeayuda@cordoba.gov.ar'}>mesadeayuda@cordoba.gov.ar</a>
            </div>
          </article>
          <img className={classes.image} src={SinPermiso} alt="logo de córdoba" />
        </section>
        <button className={classes.button} onClick={handleBack}>
          Volver
        </button>
      </div>
      <div style={{ backgroundColor: '#EFEFEF' }}>
        <Footer />
      </div>
    </div>
  );
};
